// src/pages/TopStoriesPage.js
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import API_BASE_URL from '../utils/apiConfig';
import './BreakingNewsSlider.css'; // Importing updated styles

const TopNewsCard = ({ item }) => {
    const displayImage = item.imageUrl || '/placeholder-image.png';
    const displayTitle = item.title || 'శీర్షిక లేదు';
    const displayLink = item.isApiNews ? item.link : `/news/${item.id}`;
    const linkText = item.isApiNews ? 'Read Full Article (పూర్తి కథనం చదవండి)' : 'View Post (పూర్తి వార్త చూడండి)';
    
    return (
        <div className="custom-top-news-card">
            {/* Side-by-Side Top section (Image Left, News Right) */}
            <div className="card-top-row">
                <div className="card-image-container">
                    <img 
                        src={displayImage} 
                        alt={displayTitle} 
                        className="card-image"
                        onError={(e) => { 
                            e.target.onerror = null; 
                            e.target.src = '/placeholder-image.png'; 
                        }}
                    />
                </div>
                <div className="card-info-container">
                    <span className="top-news-badge">Top News</span>
                    <h3 className="card-title">{displayTitle}</h3>
                </div>
            </div>

            {/* Full width action bar matching Category News style */}
            {item.isApiNews ? (
                <a 
                    href={displayLink} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="read-full-story-bar top-news-action"
                >
                    {linkText}
                </a>
            ) : (
                <Link 
                    to={displayLink} 
                    className="read-full-story-bar top-news-action"
                >
                    {linkText}
                </Link>
            )}
        </div>
    );
};

const BreakingNewsSlider = () => {
    const navigate = useNavigate();
    const [breakingNews, setBreakingNews] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchBreakingNews = async () => {
            try {
                const response = await axios.get(`${API_BASE_URL}/breaking-news`);
                setBreakingNews(response.data);
            } catch (error) {
                console.error("Error fetching breaking news:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchBreakingNews();
    }, []);

    if (loading) {
        return <div className="fullscreen-loader">ముఖ్య వార్తలను లోడ్ చేస్తోంది (Loading Top Stories)...</div>;
    }

    return (
        <div className="top-stories-page-container">
            {breakingNews.length === 0 ? (
                <div className="no-data-found-fullscreen">
                    <i className="fas fa-newspaper" style={{ fontSize: '4rem', color: '#ddd' }}></i>
                    <h3>వార్తలు ఏవీ లేవు</h3>
                    <p>ప్రస్తుతం ముఖ్య వార్తలు అందుబాటులో లేవు.</p>
                    <button onClick={() => navigate('/')} className="button-primary">తిరిగి హోమ్ కి వెళ్ళు</button>
                </div>
            ) : (
                <div className="top-stories-list">
                    {breakingNews.map((item, index) => (
                        <TopNewsCard key={item.id ? String(item.id) : `top-news-${index}`} item={item} />
                    ))}
                </div>
            )}
        </div>
    );
};

export default BreakingNewsSlider;